import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); refresh(); return; }
        if (data.status === "expired" || tries > 10) { setStatus("error"); return; }
      } catch { if (tries > 10) { setStatus("error"); return; } }
      tries += 1;
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div className="flex min-h-[60vh] items-center justify-center" data-testid="payment-success-page">
      <div className="max-w-md rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        {status === "checking" && (
          <>
            <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600" />
            <h1 className="mt-6 font-display text-2xl font-bold uppercase text-slate-900">Confirming payment…</h1>
            <p className="mt-2 text-sm text-slate-500">Hang tight while we activate your subscription.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" />
            <h1 className="mt-6 font-display text-2xl font-bold uppercase text-slate-900">Subscription active!</h1>
            <p className="mt-2 text-sm text-slate-500">Your plan is now active. Enjoy PropertyInspect360.</p>
            <button data-testid="go-dashboard-btn" onClick={() => nav("/app")} className="mt-6 rounded-xl bg-blue-600 px-6 py-3 font-semibold text-white hover:bg-blue-700">Go to dashboard</button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="mx-auto h-14 w-14 text-red-500" />
            <h1 className="mt-6 font-display text-2xl font-bold uppercase text-slate-900">Payment not confirmed</h1>
            <p className="mt-2 text-sm text-slate-500">We couldn't confirm your payment. Try again from billing.</p>
            <button onClick={() => nav("/app/billing")} className="mt-6 rounded-xl bg-slate-900 px-6 py-3 font-semibold text-white hover:bg-slate-800">Back to billing</button>
          </>
        )}
      </div>
    </div>
  );
}
